import cloneDeep from 'lodash.clonedeep'
import {
  FETCH_PRODUCT_STORE_REQUEST,
  FETCH_PRODUCT_STORE_SUCCESS,
  FETCH_PRODUCT_STORE_FAILURE,
  QUANTITY_CHANGE,
  FETCH_CNET_CONTENT_CHECK_UPDATE,
  UPDATE_SWATCH_MODAL_OPEN
} from '../../actionTypes/productStoreActionTypes'

import { FETCH_BUNDLES_SUCCESS } from '../../actionTypes/bundlesActionTypes'
import { FETCH_SPECIAL_OFFERS_SUCCESS } from '../../actionTypes/specialOffersActionTypes'
import { FETCH_PRODUCT_CARE_SUCCESS } from '../../actionTypes/productCareActionTypes'

const initialState = {
  data: {},
  meta: {
    errorCode: null,
    errorDetail: '',
    requestDone: null,
    swatchModalOpen: false
  }
}

const buildRequestState = oldState => {
  const newState = {
    ...oldState,
    meta: {
      ...oldState.meta,
      errorCode: null,
      errorDetail: '',
      requestDone: false
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data } = payload

  const newState = {
    ...oldState,
    data: {
      ...oldState.data,
      ...data
    },
    meta: {
      ...oldState.meta,
      errorCode: null,
      errorDetail: '',
      requestDone: true
    }
  }
  return newState
}
const buildFailureState = (oldState, payload) => {
  const { data, errorDetail, errorCode } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldState.data,
      ...data
    },
    meta: {
      errorCode,
      errorDetail,
      requestDone: true,
      swatchModalOpen: false
    }
  }
  return newState
}

const updateProduct = (oldState, payload) => {
  const newState = cloneDeep(oldState)
  newState.data = { ...newState.data, ...payload }
  return newState
}

const updateSwatchModalOpen = (oldState, payload) => {
  const newState = cloneDeep(oldState)
  newState.meta = { ...newState.meta, ...payload }

  return newState
}

const productStoreReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_PRODUCT_STORE_REQUEST:
      return buildRequestState(state)
    case FETCH_PRODUCT_STORE_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_PRODUCT_STORE_FAILURE:
      return buildFailureState(state, payload)
    case UPDATE_SWATCH_MODAL_OPEN:
      return updateSwatchModalOpen(state, payload)
    case FETCH_BUNDLES_SUCCESS:
    case FETCH_SPECIAL_OFFERS_SUCCESS:
    case QUANTITY_CHANGE:
    case FETCH_CNET_CONTENT_CHECK_UPDATE:
    case FETCH_PRODUCT_CARE_SUCCESS:
      return updateProduct(state, payload)
    default:
      return state
  }
}

export { initialState, productStoreReducer }
